import type { EnemyInstance, GridCoordinate, TargetingMode } from "../domain/types";
import { isTargetable } from "./enemy-lifecycle";

const squaredDistance = (a: { x: number; y: number }, b: { x: number; y: number }): number =>
  (a.x - b.x) ** 2 + (a.y - b.y) ** 2;
export function selectTargets(
  enemies: readonly EnemyInstance[],
  towerPosition: GridCoordinate,
  range: number,
  mode: TargetingMode,
  count = 1,
): EnemyInstance[] {
  const eligible = enemies.filter(
    (enemy) => isTargetable(enemy) && squaredDistance(enemy.position, towerPosition) <= range ** 2,
  );
  eligible.sort((a, b) => {
    let comparison = 0;
    if (mode === "first") comparison = a.distanceToExit - b.distanceToExit;
    else if (mode === "last") comparison = b.distanceToExit - a.distanceToExit;
    else if (mode === "strongest") comparison = b.health - a.health;
    else if (mode === "weakest") comparison = a.health - b.health;
    else
      comparison =
        squaredDistance(a.position, towerPosition) - squaredDistance(b.position, towerPosition);
    return comparison || a.id.localeCompare(b.id);
  });
  return eligible.slice(0, count);
}
